import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://festivalplan.app";
const DEFAULT_DESC = "Plane Gruppen, Packlisten, Fahrgemeinschaften, Aufgaben und Gruppenkasse in einer einzigen App.";

export const PAGE_META = {
  "/": { title: "FestivalPlan – Gemeinsam Festivals planen", description: DEFAULT_DESC },
  "/features": { title: "Features – FestivalPlan", description: "Gruppen, Gruppenchat, Packliste, Fahrgemeinschaft, Gruppenkasse, Aufgaben und FestivalNavigator – alle Funktionen von FestivalPlan im Überblick." },
  "/download": { title: "Download – FestivalPlan für iOS & Android", description: "FestivalPlan kostenlos laden: offiziell für Android im Google Play Store und für iPhone im Apple App Store." },
  "/faq": { title: "Häufige Fragen (FAQ) – FestivalPlan", description: "Antworten auf häufige Fragen zu FestivalPlan: Kosten, Accounts, mehrere Festivals, Datensicherheit, Push-Benachrichtigungen und Gruppenkasse." },
  "/ueber-uns": { title: "Über uns – FestivalPlan", description: "Die Geschichte hinter FestivalPlan: von der Idee auf dem Festival zur App – made from the Crew for the Crew." },
  "/support": { title: "Support & Kontakt – FestivalPlan", description: "Hilfe, häufige Fragen, technische Probleme, Feedback und Kontakt zum FestivalPlan-Support." },
  "/datenschutz": { title: "Datenschutzerklärung – FestivalPlan", description: "Informationen zur Verarbeitung personenbezogener Daten bei der Nutzung der FestivalPlan-App und -Website (DSGVO)." },
  "/impressum": { title: "Impressum – FestivalPlan", description: "Anbieterkennzeichnung und Kontaktangaben zu FestivalPlan gemäß § 5 DDG." },
  "/agb": { title: "Allgemeine Geschäftsbedingungen – FestivalPlan", description: "Allgemeine Geschäftsbedingungen für die Nutzung der FestivalPlan-App und -Website." },
  "/nutzungsbedingungen": { title: "Nutzungsbedingungen – FestivalPlan", description: "Regeln und Informationen zur Nutzung von FestivalPlan – Stand September 2026." },
  "/konto-loeschen": { title: "Konto löschen – FestivalPlan", description: "So löschst du dein FestivalPlan-Benutzerkonto und deine Daten." },
};

const NOT_FOUND_META = { title: "Seite nicht gefunden – FestivalPlan", description: "Die angeforderte Seite existiert nicht. Zurück zur FestivalPlan-Startseite." };

function setMeta(selector, attr, value) {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
}

export default function PageMeta() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;
    const meta = PAGE_META[path] || NOT_FOUND_META;
    const url = `${SITE}${path === "/" ? "/" : path}`;
    document.title = meta.title;
    setMeta('meta[name="description"]', "content", meta.description);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.description);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[name="twitter:title"]', "content", meta.title);
    setMeta('meta[name="twitter:description"]', "content", meta.description);
    setMeta('link[rel="canonical"]', "href", url);
    setMeta('meta[name="robots"]', "content", PAGE_META[path] ? "index,follow" : "noindex,follow");
  }, [pathname]);
  return null;
}
